export interface ColorMode {
	light: string;
	dark: string;
}

export type Color = string | ColorMode;

export const getColor = (color: Color): string => {
	if (typeof color === "string") return color;
	if (window.matchMedia("(prefers-color-scheme: dark)").matches === true) {
		return color.dark;
	}
	return color.light;
};

export interface Props {
	color: Color;
}
